import { LocalStorageKeys } from '@/constants'
import { IStore } from '@/store'
import { cache } from '../cache'
/**
 * 手动设置本地存储里的全局状态, 用于在vuex没有准备好无法commit的setup阶段使用(如在微前端环境中手动把主应用的信息同步到本地, 当前应用mount之后vuex会把此信息作为初始值, 实现主子应用同步)
 */
export const setLocalGlobalState = (state: IStore) => cache.set(LocalStorageKeys.GLOBAL_STATE, state)
